import {
  faExpand,
  faHeart,
  faMagnifyingGlass,
  faSearch,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useContext, useEffect } from "react";

import "./Heart_Component.css";
import { Button, Card } from "react-bootstrap";

import { Context } from "../../../utils/context";

import { useNavigate } from "react-router-dom";
import { addWishlist } from "../../../utils/apis/Wishlist/Wishlist";

function Heart_Component({
  product,
  variant,
  m_varient,
  handleShowModalClick,
}) {
  const { wishlistData, signin, wishlistContext, setShimmerLoader } =
    useContext(Context);
  const navigate = useNavigate();
  const handleHeartClick = async () => {
    setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist({
        product_id: product?.id,
        variant_id: variant?.id,
        m_variant_id: m_varient?.id,
      });
      if (res?.success) {
        wishlistContext();
      }
      setShimmerLoader(false);
    } else {
      // setShimmerLoader(false);
      navigate("/login");
    }
  };

  return (
    <>
      <div className="hearticn">
        <div className="heart_icon" onClick={handleHeartClick}>
          <FontAwesomeIcon
            icon={faHeart}
            className={
              wishlistData?.some(
                (item) =>
                  (item.product_id === product?.id &&
                    item.variant_id === variant?.id) ||
                  (item.product_id === product?.id &&
                    item.m_variant_id === m_varient?.id)
              )
                ? "gobiheartss"
                : "gobiheart"
            }
          />
        </div>

        <div
          className="heart_icon magnify_circle"
          onClick={handleShowModalClick}
        >
          <FontAwesomeIcon icon={faExpand} className="magnify" />
        </div>

        {/* <div className="heart_icon share_icon">
          <FontAwesomeIcon
            icon={faShareNodes}
            className="Share_logo  "
          />
        </div> */}
      </div>
    </>
  );
}

export default Heart_Component;
